import { metrics } from '@atlassian/browser-metrics';
import type { Metric } from '@atlassian/browser-metrics/types';

import type { ChatModeParams } from './ChatModeParams';
import { getMessageMetricsNameWithParams } from './getMessageMetricsNameWithParams';

// Reconnection metrics
const TIME_TO_CONNECT_TO_STREAM_METRICS_KEY = 'ai-mate.reconnect.time-to-connect-to-stream';

const TIME_TO_FIRST_CHUNK_RECEIVED_METRICS_KEY = 'ai-mate.reconnect.time-to-first-chunk-received';

export const reconnectionMetrics = {
	createTimeToConnectToStreamMetrics: (params: ChatModeParams): Metric => {
		return metrics.interaction({
			key: getMessageMetricsNameWithParams(TIME_TO_CONNECT_TO_STREAM_METRICS_KEY, params),
		});
	},
	createTimeToResumeStreamMetrics: (params: ChatModeParams): Metric => {
		return metrics.interaction({
			key: getMessageMetricsNameWithParams(TIME_TO_FIRST_CHUNK_RECEIVED_METRICS_KEY, params),
		});
	},
};
